import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

jQuery(function ($) {
	const grids = document.querySelectorAll('.JS-masonry-grid');
	if (grids) {
		grids.forEach((grid) => {
			var msnry = new Masonry(grid, {
				itemSelector: '.JS-masonry-grid-item',
				columnWidth: '.JS-masonry-grid-item',
				percentPosition: true,
				gutter: 15,
			});
			$(grid).data('masonry', msnry);
			imagesLoaded(grid, () => msnry.layout());
		});
	}
});
